import { render, staticRenderFns } from "./Prodotti.vue?vue&type=template&id=7743ad18&scoped=true"
import script from "./Prodotti.vue?vue&type=script&lang=js"
export * from "./Prodotti.vue?vue&type=script&lang=js"
import style0 from "./Prodotti.vue?vue&type=style&index=0&id=7743ad18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7743ad18",
  null
  
)

export default component.exports